export function NavUser({ children }) {
  return <div className="nav__user">{children}</div>;
}
